import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }: Theme) => ({
  icon: {
    color: palette.primary.main,
    fontSize: 28,
  },
}));
